module.exports = __webpack_public_path__ + "static/c22-ab96fa5d2d77ffed81f7213c8c23da90.jpg";